import React from "react";
import { Clock } from "lucide-react";

const PRESETS = [["", "Tutto il giorno"], ["6-12", "Mattina 6-12"], ["12-15", "Pranzo 12-15"], ["15-18", "Pomeriggio 15-18"], ["18-21", "Sera 18-21"], ["21-24", "Notte 21-24"]];
const H = Array.from({ length: 25 }, (_, i) => i);

export function HoursFilter({ value, onChange, testid = "crm-hours-filter" }) {
  const [from, to] = value ? value.split("-").map(Number) : [0, 24];
  const set = (a, b) => onChange(a === 0 && b === 24 ? "" : `${a}-${b}`);
  const isPreset = PRESETS.some(([v]) => v === (value || ""));
  return (
    <div className="flex items-center gap-1.5" data-testid={testid} title="Fascia oraria degli scontrini (ora di emissione)">
      <Clock className="h-3.5 w-3.5 text-zinc-500" />
      <select value={isPreset ? value || "" : "custom"} onChange={(e) => { if (e.target.value !== "custom") onChange(e.target.value); }} data-testid={`${testid}-preset`} className="h-8 rounded-md bg-zinc-950 border border-zinc-800 text-xs px-2">
        {PRESETS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
        {!isPreset && <option value="custom">Personalizzata</option>}
      </select>
      <select value={from} onChange={(e) => { const a = Number(e.target.value); set(a, Math.max(to, a + 1)); }} data-testid={`${testid}-from`} className="h-8 rounded-md bg-zinc-950 border border-zinc-800 text-xs px-1 font-mono">
        {H.slice(0, 24).map((h) => <option key={h} value={h}>{String(h).padStart(2, "0")}</option>)}
      </select>
      <span className="text-[11px] text-zinc-500">→</span>
      <select value={to} onChange={(e) => { const b = Number(e.target.value); set(Math.min(from, b - 1), b); }} data-testid={`${testid}-to`} className="h-8 rounded-md bg-zinc-950 border border-zinc-800 text-xs px-1 font-mono">
        {H.slice(1).map((h) => <option key={h} value={h}>{String(h).padStart(2, "0")}</option>)}
      </select>
      {value && <button type="button" onClick={() => onChange("")} data-testid={`${testid}-clear`} className="text-[11px] text-zinc-500 hover:text-zinc-200 underline">tutto</button>}
    </div>
  );
}
